/**
 * Mimic jQuery $.getScripts function
 */
export default (scriptUrl: string, callback: () => void) => {
  const script = document.createElement('script');
  script.src = scriptUrl;
  script.async = true;
  script.onload = callback;

  document.body.appendChild(script);
};
